module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av277-8ef7a69ceeea4f8ef4b0ab12818d13d7.jpg";